import { Injectable, inject } from '@angular/core';
import { IndexedDbService, ApiConfig } from './indexed-db.service';
import { EnvironmentService } from '../core/services/environment.service';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private _appConfig: ApiConfig;
  private environmentService = inject(EnvironmentService);
  private initialized = false;

  constructor(private indexedDb: IndexedDbService) {
    // Don't access EnvironmentService in constructor to avoid circular dependency
    this._appConfig = {
      baseUrl: '' // Will be set in init()
    };
  }

  get appConfig(): ApiConfig {
    this.init();
    return this._appConfig;
  }

  private init(): void {
    if (this.initialized) return;

    const apiBaseUrl = this.environmentService.apiBaseUrl;
    this._appConfig.baseUrl = apiBaseUrl;
    this._appConfig.timeout = this.environmentService.apiTimeout;

    this.indexedDb.put('api_config', {
      baseUrl: apiBaseUrl,
      timeout: this.environmentService.apiTimeout
    }, 'default');

    console.log(`ApiConfig initialized with API base URL: ${apiBaseUrl}`);
    this.initialized = true;
  }

  private getApiBaseUrl(): string {
    return this.environmentService.apiBaseUrl;
  }

  public async loadConfig(): Promise<ApiConfig> {
    this.init();
    // Return the configured app config
    const config = await this.indexedDb.get('api_config', 'default');
    if (config) {
      this._appConfig = config as ApiConfig;
    }
    return this._appConfig;
  }

  public async updateApiBaseUrl(baseUrl: string): Promise<void> {
    this.init();
    this._appConfig.baseUrl = baseUrl;
    await this.indexedDb.put('api_config', this._appConfig, 'default');
  }
}
